import { render, staticRenderFns } from "./EditFeature.vue?vue&type=template&id=b6a9e12c&scoped=true&"
import script from "./EditFeature.vue?vue&type=script&lang=js&"
export * from "./EditFeature.vue?vue&type=script&lang=js&"
import style0 from "./EditFeature.vue?vue&type=style&index=0&id=b6a9e12c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a9e12c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSwitch,VTextField})
